// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminReleaseNoteReactionsResponse

import { hydrateReleaseNoteReaction, type ReleaseNoteReaction, type ReleaseNoteReactionApiResponse } from './releaseNoteReaction.gen';

export type AdminReleaseNoteReactionsApiResponse = {
	items: ReleaseNoteReactionApiResponse[];
};

export type AdminReleaseNoteReactions = {
	items: ReleaseNoteReaction[];
};

export function hydrateAdminReleaseNoteReactions(data: AdminReleaseNoteReactionsApiResponse): AdminReleaseNoteReactions {
	return {
		...data,
		items: data.items.map(hydrateReleaseNoteReaction),
	};
}